// Recovered compiled webpack factory 30249. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  r.d(t, { D0: () => u, De: () => l, sv: () => i, yD: () => s });
  var n = r(61571),
    a = r(43275),
    o = r(16649);
  let i = "sentry-";
  function s(e) {
    let t = u(e);
    if (!t) return;
    let r = Object.entries(t).reduce(
      (e, [t, r]) => (t.startsWith(i) && (e[t.slice(i.length)] = r), e),
      {},
    );
    return Object.keys(r).length > 0 ? r : void 0;
  }
  function l(e) {
    if (e) {
      var t = Object.entries(e).reduce((e, [t, r]) => (r && (e[`${i}${t}`] = r), e), {});
      return 0 !== Object.keys(t).length
        ? Object.entries(t).reduce((e, [t, r], o) => {
            let i = `${encodeURIComponent(t)}=${encodeURIComponent(r)}`,
              s = 0 === o ? i : `${e},${i}`;
            return s.length > 8192
              ? (n.T &&
                  a.Yz.warn(
                    `Not adding key: ${t} with val: ${r} to baggage header due to exceeding baggage size limits.`,
                  ),
                e)
              : s;
          }, "")
        : void 0;
    }
  }
  function u(e) {
    if (e && ((0, o.Kg)(e) || Array.isArray(e)))
      return Array.isArray(e)
        ? e.reduce(
            (e, t) => (
              Object.entries(c(t)).forEach(([t, r]) => {
                e[t] = r;
              }),
              e
            ),
            {},
          )
        : c(e);
  }
  function c(e) {
    return e
      .split(",")
      .map((e) => {
        let t = e.indexOf("=");
        return -1 === t
          ? []
          : [e.slice(0, t), e.slice(t + 1)].map((e) => {
              try {
                return decodeURIComponent(e.trim());
              } catch {
                return;
              }
            });
      })
      .reduce((e, [t, r]) => (t && r && (e[t] = r), e), {});
  }
}
